import { Pencil, Trash2 } from 'lucide-react';
import { Button, type ButtonProps } from '../../components/buttons/Button';
import { useSectionList } from './SectionListContext';

export interface SectionListRowButtonsProps {
	editButtonProps?: ButtonProps;
	removeButtonProps?: ButtonProps;
	buttonSlot?: React.ReactNode;
}

export function SectionListRowButtons({ editButtonProps, removeButtonProps, buttonSlot }: SectionListRowButtonsProps) {
	const { canEdit } = useSectionList();
	if (!canEdit || (!editButtonProps && !removeButtonProps)) {
		return null;
	}
	return (
		<div className="flex items-start gap-1">
			{buttonSlot}
			{editButtonProps && (
				<Button
					{...editButtonProps}
					label={undefined}
					aria-label={editButtonProps.label}
					size="xs"
					appearance="ghost"
					intent="neutralLight"
					useSuspense
					Icon={Pencil}
					useTooltip
				/>
			)}
			{removeButtonProps && (
				<Button
					{...removeButtonProps}
					label={undefined}
					aria-label={removeButtonProps.label}
					size="xs"
					appearance="ghost"
					intent="neutralLight"
					useSuspense
					Icon={Trash2}
					useTooltip
				/>
			)}
		</div>
	);
}
